import defaultTheme from "./default";

const themes = {
  defaultTheme
};

export default themes;
